import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API from "../../config/config";

const RequestOTP = () => {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleGenerateOtp = async () => {
    if (!phone || phone.length < 10) {
      setMessage("Please enter a valid mobile number");
      return;
    }

    try {
      setLoading(true);
      setMessage("");
      const res = await axios.post(API.ADMIN.REQUESTOTP, {
        phone,
        role: "driver",
      });

      const { otp, code, isNewUser } = res.data.data;

      // Navigate and pass all needed data
      navigate("/verify-otp", {
        state: {
          phone,
          otp,
          code,
          isNewUser,
        },
      });
    } catch (error) {
      console.error(error);
      setMessage(error?.response?.data?.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4">
      <div className="w-full max-w-sm">
        <h1 className="text-2xl font-bold text-center mb-8">Login</h1>

        <label className="block text-left font-semibold mb-1">
          Enter your mobile number
        </label>
        <input
          type="tel"
          placeholder="Enter valid 10 digit mobile number"
          value={phone}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, ""); // Remove all non-digit characters
            if (value.length <= 10) {
              setPhone(value);
            }
          }}
          maxLength={10}
          className="w-full p-4 border border-black rounded-lg text-base mb-6 focus:outline-none"
        />

        <button
          onClick={handleGenerateOtp}
          disabled={loading || phone.length !== 10}
          className={`w-full font-semibold py-3 rounded-xl shadow-md transition 
    ${
      phone.length === 10 && !loading
        ? "bg-black text-white hover:opacity-90"
        : "bg-gray-300 text-gray-600 cursor-not-allowed"
    }
  `}
        >
          {loading ? "Sending..." : "Generate OTP"}
        </button>

        {message && (
          <p
            className={`mt-4 text-center text-sm font-medium ${
              message?.toLowerCase().includes("failed") ||
              message?.toLowerCase().includes("too many")
                ? "text-red-600"
                : "text-green-600"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default RequestOTP;
